import React, { FC } from 'react';
import { Card } from 'components/ui';
import { Field } from 'react-final-form';
import { SelectWithRolesFieldsWrapper } from 'components/forms';

const AppScope: FC = () => (
  <Card title='form.step.app.scope.title'>
    <Field
      name='roles'
      label='form.field.label.app.scope'
      dropdownPlaceholder='app.create.form.scope.placeholder'
      component={SelectWithRolesFieldsWrapper}
      hasScrollFieldgroup
      isRemoveEnabled
      addSelectedOptionInFront
    />
  </Card>
);

export default AppScope;
